import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { PageTabRail } from '@interxfi/app-components/components/page-tab-rail/page-tab-rail';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { VerticalStack } from '@interxfi/design-system/components/alignment/vertical-stack';
import { Button } from '@interxfi/design-system/components/button/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { IceJobCreateDrawer } from '../../../../../../../../../../features/vendor/ice/job/ice-job-create-drawer';
import { IceJobsTable } from '../../../../../../../../../../features/vendor/ice/job/ice-jobs-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/job/_job/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingVendorIce,
      label: 'Jobs',
      order: 2,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingVendorIce>,
  head: () => getPageHead('ICE Jobs'),
  component: IceJobsList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <VerticalStack gap={7}>
      <PageTabRail
        actions={
          <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
            <RequiresAccess write>
              <IceJobCreateDrawer trigger={<Button affixIcon={<PlusIcon aria-hidden />} aria-label="New Job" size="small" />} />
            </RequiresAccess>

            {filter}
          </HorizontalStack>
        }
        group={TabbedNavigationGroup.ClearingVendorIce}
      />
    </VerticalStack>
  );
}

function IceJobsList() {
  return (
    <PageLayout>
      <PageLayout.Section>
        <IceJobsTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
